export default __webpack_public_path__ + "static/media/8f0d0b58d242a35f.ecfcc732081606d528f45cc6f6743b13.svg";